import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "Notre vision", text: "La discrétion et la ponctualité ne sont pas des options. Chaque trajet est orchestré comme une évidence : vous montez, nous nous occupons du reste." },
  { n: "02", title: "Chauffeurs certifiés", text: "Des professionnels agréés VTC, formés au protocole d'accueil, maîtrisant Paris et ses accès comme leur propre itinéraire." },
  { n: "03", title: "Toyota C-HR hybride", text: "Un SUV hybride récent, silencieux et confortable, entretenu avec exigence. Chargeurs et eau minérale à bord, systématiquement." },
  { n: "04", title: "Tarifs fixes", text: "Le prix affiché lors de votre réservation est le prix payé. Aucun supplément surprise, aucun compteur qui tourne dans les embouteillages." },
];

export const Chapters = () => (
  <section id="manifeste" className="py-20 lg:py-32 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto" data-testid="manifesto-section">
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
      className="text-xs uppercase tracking-[0.25em] font-mono text-amber-700/80 font-semibold mb-6"
    >
      Le manifeste
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay: 0.1, ease: [0.215, 0.61, 0.355, 1] }}
      className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] max-w-2xl mb-16 lg:mb-24"
    >
      Quatre engagements, <span className="italic text-gold">un seul standard.</span>
    </motion.h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0">
      {CHAPTERS.map((c, i) => (
        <motion.article
          key={c.n}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.215, 0.61, 0.355, 1] }}
          className="grid grid-cols-12 gap-6 border-t border-[#E6E1D8] pt-10 pb-12 group"
          data-testid={`manifesto-chapter-${c.n}`}
        >
          <span className="col-span-2 font-mono text-sm text-gold">{c.n}</span>
          <div className="col-span-10">
            <h3 className="text-xl sm:text-2xl font-medium text-obsidian mb-4 group-hover:text-gold transition-colors duration-300">{c.title}</h3>
            <p className="text-sm sm:text-base leading-relaxed text-neutral-600">{c.text}</p>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
